module.exports = __webpack_public_path__ + "static/biennale-hair-it-fc05ddca2548cc00f41081ddbde40188.otf";